import { useTranslate } from '@refinedev/core';
import { Tag } from 'antd';
import { ReadOutlined, SoundOutlined } from '@ant-design/icons';
import type { ProductKind } from './productKind';

/** Which format a settlement row's product is: ebook or audiobook. */
export const ProductFormatTag = ({ kind }: { kind: ProductKind }) => {
  const t = useTranslate();

  return (
    <Tag
      icon={kind === 'ebook' ? <ReadOutlined /> : <SoundOutlined />}
      color={kind === 'ebook' ? 'blue' : 'purple'}
    >
      {t(`user_catalog.publications.tabs.${kind}`)}
    </Tag>
  );
};
